export enum ForbrugsnotifikationType {
    brev = 1,
    sms = 2,
    mail = 3
}

export enum ForbrugsnotifikationFrekvens {
    daglig = 1,
    ugentlig = 2,
    maanedlig = 3
}

export interface ForbrugsnotifikationOpsaetning {
    forbrug: ForbrugsnotifikationSektionOpsaetning;
    retur: ForbrugsnotifikationSektionOpsaetning;
    udsendelse: ForbrugsnotifikationUdsendelseOpsaetning;
}

export interface ForbrugsnotifikationSektionOpsaetning {
    brugerdefineret: boolean;
    vaerdi: number;
}

export interface ForbrugsnotifikationUdsendelseOpsaetning {
    type: ForbrugsnotifikationType;
    frekvens: ForbrugsnotifikationFrekvens;
    mail: string;
    mobil: string;
}
